import ImgLogoBranch from "../assets/svg/branch-add-new.svg";
import {apiAddCostCenters, apiGetCostCenter, apiUpdateCostCenter} from "../api/costCenterApi";

export const costCenterFormData = {
  key: "costCenter",
  title: "مرکز هزینه",
  addFunction: apiAddCostCenters,
  getFunction: apiGetCostCenter,
  updateFunction: apiUpdateCostCenter,
  navigation: {
    title: "افزودن مرکز هزینه",
    backTitle: "بازگشت",
    backUrl: "/costCenters",
  },
  summaryInfo: {
    key: "costCenter",
    primaryTitleKey: "title",
    addTempTitle: "افزودن مرکز هزینه جدید",
    saveTitle: "ذخیره مرکز هزینه",
    defaultImage: ImgLogoBranch,
  },
  tabs: [
    {
      key: "costCenter",
      name: "مرکز هزینه",
      form: {
        main: {
          wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
          imagePicker: {
            active: false,
          },
          initialInputs: {
            inputs: [
              {
                wrapperClass: "col-lg-7 col-md-7 col-sm-7 col-xs-12",
                name: "title",
                label: "عنوان مرکز هزینه",
                required: true,
                primary: true,
                maxLength: 32,
                style: {
                  paddingRight: "60px",
                  paddingLeft: "50px",
                },
              },
              {
                wrapperClass: "col-lg-7 col-md-7 col-sm-7 col-xs-12",
                name: "code",
                label: "کد مرکز هزینه",
                required: true,
                primary: true,
                numberOnly:true,
                maxLength: 10,
                style: {
                  paddingRight: "60px",
                  paddingLeft: "50px",
                },
              },
            ],
          },
          inputs: [],
        },
      },
    },
  ],
};
